import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderService } from 'src/app/services/order/order.service';
import { Orderheader } from 'src/app/model/orderheader.model';

@Component({
  selector: 'app-confirmrepeatorder',
  templateUrl: './confirmrepeatorder.component.html',
  styleUrls: ['./confirmrepeatorder.component.css']
})
export class ConfirmrepeatorderComponent implements OnInit {

  orderNo: string;
  orderHeader: any;
  data: any;
  isNotAgreed: boolean = true;
  orderConfirmed: boolean = false;

  constructor(private route: ActivatedRoute, private router: Router,
    private orderServices: OrderService) {
    this.orderNo = this.route.snapshot.params.ordernumber;
    //alert(this.orderNo);
  }

  ngOnInit() {
    this.getPlacedOrder();
  }

  getPlacedOrder() {
    this.orderServices.getPlacedOrderItem(this.orderNo).subscribe(
      (data: any) => {
        this.orderHeader = data;
        this.data = this.orderHeader.orderDetail;
        if (this.orderHeader.acknowledge == true) {
          this.isNotAgreed = false;
        }
        console.log(this.orderHeader);
      }
    )
  }

  agreeCond(e) {
    if (e.target.checked) {
      this.isNotAgreed = false;
    }
    else {
      this.isNotAgreed = true;
    }
  }

  confirmOrder() {
    this.isNotAgreed = true;
    console.log(this.orderHeader);
    //alert("Order Confirmed");
    this.orderServices.confirmOrder(this.orderHeader).subscribe(
      (data: any) => {
        if (data == true) {

          //alert("Order Confirmed");
          this.orderConfirmed = true;
        }
        else {
          alert("Order Failed");
          this.orderConfirmed = false;
        }
      }
    )
  }

  // printRecipt(divName: string) {

  //   var printContents = document.getElementById(divName).innerHTML;
  //   var originalContents = document.body.innerHTML;

  //   document.body.innerHTML = printContents;

  //   window.print();

  //   document.body.innerHTML = originalContents;

  // }

  printRecipt() {

    //var printContents = document.getElementById(divName).innerHTML;
    //var originalContents = document.body.innerHTML;
    //document.body.innerHTML = printContents;
    //window.print();
    //document.body.innerHTML = originalContents;

    let printContents, popupWin;
    printContents = document.getElementById('printableContent').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Mother Parkers Tea &amp; Coffee Inc.</title>
          <style>
          #tabledata th
          {
            text-align:left;
          }
          body
          {
            margin-top:20px;
          }
          #signSection
          {
            margin-top:10px;
          }
          #signLine
          {
            margin-top:50px !Important;
          }
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();

  }

  changeOrder() {
    this.router.navigate(['/repeatorder', this.orderNo]);
  }

  navigateOrderScreen() {
    this.router.navigate(['/myorders']);
  }


}
